import React from 'react';
// Assuming you have installed react-icons
import { FaPhone, FaMapMarkerAlt, FaEnvelope, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa'; // Added FaYoutube

const Footer: React.FC = () => {
    // Placeholder URL for the dark soil/compost background image
    const FOOTER_BACKGROUND_IMAGE = "https://radhakrishnaagriculture.in/cdn/shop/files/organic-vermicompost.jpg?v=1710918465"; 

    // Define the link items
    const quickLinks = [
        { name: "Home", href: "/" },
        { name: "About Us", href: "/about" },
        { name: "Our Products", href: "/gallery" },
        { name: "Contact Us", href: "/contact" },
    ];
    
    const downloadLinks = [
        { name: "FAQ's", href: "/faq" },
        { name: "Privacy Policy", href: "/privacy" },
        { name: "Terms and Conditions", href: "/terms" },
    ];

    return (
        <footer className="w-full bg-white text-gray-200">
            
            {/* 1. Top Query/Contact Section (Green Banner) */}
            <div className="bg-[#4f6a39] py-8 sm:py-10 px-4 sm:px-8"> {/* Adjusted padding for better mobile fit */}
                <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                    <div className="text-white text-center md:text-left">
                        <p className="text-sm font-semibold tracking-wider">YOU HAVE QUERY?</p>
                        <h2 className="text-2xl sm:text-4xl font-bold mt-1">Then Contact Us</h2> {/* Adjusted text size for responsiveness */}
                    </div>
                    <div className="flex space-x-4">
                        <a 
                            href="/contact" 
                            className="bg-transparent text-white border-2 border-white hover:bg-white hover:text-[#4f6a39]
                                       px-5 py-2 sm:px-6 font-semibold rounded transition-colors duration-300 text-sm sm:text-base" 
                        >
                            CONTACT US
                        </a>
                    </div>
                </div>
            </div>

            {/* 2. Main Info Section (Over Background Image) */}
            <div 
                className="py-12 sm:py-16 px-4 sm:px-8 relative bg-cover bg-center" 
                style={{ backgroundImage: `url(${FOOTER_BACKGROUND_IMAGE})` }}
            >
                {/* Dark Overlay for Readability */}
                <div className="absolute inset-0 bg-black opacity-70"></div>
                
                {/* Content Columns - KEY RESPONSIVE CHANGE HERE */}
                <div className="relative z-10 max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-8 text-white">
                    
                    {/* Column 1: Contact Info */}
                    <div>
                        <h4 className="text-xl font-bold mb-6 border-b-2 border-white pb-2">Contact Info</h4>
                        <div className="space-y-4 text-sm">
                            <div className="flex items-center space-x-3">
                                <FaPhone className="text-white flex-shrink-0" />
                                <p className="font-semibold">+91 7830694633</p>  
                            </div>
                            <div className="flex items-center space-x-3">
                                <FaPhone className="text-white flex-shrink-0" />
                                <p className="font-semibold">+91 7668420282</p>  
                            </div>
                            {/* Ensured phone numbers stack cleanly on mobile */}
                            <div className="flex items-center space-x-3"> 
                                <FaPhone className="text-white flex-shrink-0" />
                                <p className="font-semibold">+91 6395178971</p>  
                            </div>
                        </div>
                    </div>

                    {/* Column 2: Reach Us */}
                    <div>
                        <h4 className="text-xl font-bold mb-6 border-b-2 border-white pb-2">Reach Us</h4>
                        <div className="space-y-4 text-sm">
                            <div className="flex items-start space-x-3">
                                <FaMapMarkerAlt className="text-white mt-1 flex-shrink-0 text-2xl" />
                                <div>
                                    {/* <p className="font-extrabold">Location</p> */}
                                    <p className="font-semibold">Village Lalpur, near Delhi Lucknow Highway</p>
                                </div>
                            </div>
                            <div className="flex items-center space-x-3">
                                <FaEnvelope className="text-white flex-shrink-0 text-2xl" />
                                <div>
                                    {/* <p className="font-extrabold">Email Us</p> */}
                                    <p className="font-semibold">info@bareillyvermicompost.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* Column 3: Quick Links */}
                    <div>
                        <h4 className="text-xl font-bold mb-6 border-b-2 border-white pb-2">Quick Links</h4>
                        <ul className="space-y-2 text-sm font-semibold">
                            {quickLinks.map((link) => (
                                <li key={link.name}><a href={link.href} className="text-white transition-colors duration-200 block hover:text-[#4f6a39]">{`> ${link.name}`}</a></li> 
                            ))}
                        </ul>
                    </div>

                    {/* Column 4: Downloads */}
                    <div>
                        <h4 className="text-xl font-bold mb-6 border-b-2 border-white pb-2">Downloads</h4>
                        <ul className="space-y-2 text-sm font-semibold">
                            {downloadLinks.map((link) => (
                                <li key={link.name}><a href={link.href} className="text-white transition-colors duration-200 block hover:text-[#4f6a39]">{`> ${link.name}`}</a></li> 
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            {/* 3. Bottom Copyright Bar */}
            <div className="bg-black py-4 px-4 sm:px-8">
                {/* flex-col on mobile, flex-row from md breakpoint */}
                <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center text-sm space-y-2 md:space-y-0">
                    <p className="text-gray-400 text-center md:text-left">
  © All rights reserved by Bareilly Vermi Compost / Website Developed by{" "}
  <a
    href="https://nadezhda.in"
    target="_blank"
    rel="noopener noreferrer"
    className="text-green-500 hover:text-green-400 underline"
  >
    Nadezhda Venture Pvt. Ltd.
  </a>
</p>

                    {/* Social Icons */}
                    <div className="flex space-x-4 text-lg">
                        <a href="#" className="text-white hover:text-[#4f6a39] transition-colors duration-200"><FaFacebookF /></a>
                        <a href="#" className="text-white hover:text-[#4f6a39] transition-colors duration-200"><FaTwitter /></a>
                        <a href="#" className="text-white hover:text-[#4f6a39] transition-colors duration-200"><FaInstagram /></a>
                        <a href="#" className="text-white hover:text-[#4f6a39] transition-colors duration-200"><FaLinkedinIn /></a>
                        <a href="#" className="text-white hover:text-[#4f6a39] transition-colors duration-200"><FaYoutube /></a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;